import React from "react";
import CONFIG from "../../config";
import SocNet from "../../components/SocNet/SocNet";
import About from "../../components/About/About";
import Complain from "../../components/Complain/Complain";
import Additionally from "../../components/Additionally/Additionally";
import Loans from "../../components/Loans/Loans";
import BaibolLogo from "../../components/BaibolLogo/BaibolLogo";
import BaibolPhone from "../../components/BaibolPhone/BaibolPhone";

import downloadApk from '../../assets/img/download-apk.svg';

const { LINKS } = CONFIG;

const Footer: React.FC = () => (
    <footer>
        <div className="footer__main">
            <div className="footer__wrapper">
                <div className="footer__top">
                    <div className="footer__logo">
                        <BaibolLogo isWhite={true} />
                        <a className="footer__download-apk" href={LINKS.APPS.APK}>
                            <img src={downloadApk} alt="Скачать .apk Байбол Онлайн" /> :
                        </a>
                    </div>
                    <nav className="footer__menu">
                        <ul>
                            <li>
                                <h6>О компании</h6>
                                <About />
                            </li>
                            <li>
                                <h6>Займы</h6>
                                <Loans />
                            </li>
                        </ul>
                    </nav>
                    <Complain parentClass="footer__complain" />
                    <div className="footer__dop__link">
                        <h6>Дополнительно</h6>
                        <Additionally isFooter={true} />
                    </div>
                    <BaibolPhone additionalClass="ff__mobile" />
                </div>
                <div className="footer__mid">
                    <div className="footer__copyright">
                        &copy; 2016-2025 ООО МКК «Байбол»
                        <span>Регистрационный номер в реестре МФО ЦБ РФ — 1603140007889</span>
                    </div>
                    <BaibolPhone />
                    <SocNet isFooter={true} />
                </div>
            </div>
        </div>
        <div className="footer__bottom">
            <div className="footer__wrapper">
                <div className="footer__bottom__left">
                    <p>Общество с ограниченной ответственностью Микрокредитная компания «Байбол» (ООО МКК «Байбол»)
                        зарегистрировано в реестре МФО ЦБ РФ за номером 1603140007889 от 10.08.2016 года. ИНН
                        7810444350. ОГРН 1167847251000. Юридический адрес: 194100, г. Санкт-Петербург, ул.
                        Литовская, д. 4, лит. А, офис 301. Электронная почта: <a href="mailto:info@baibol.ru">info@baibol.ru</a>.
                    </p>
                    <p>ООО МКК "Байбол" является членом Саморегулируемой организации Союз микрофинансовых
                        организаций «Микрофинансирование и Развитие» (СРО "МиР"), дата вступления: 21.03.2017,
                        адрес: 107078, г. Москва Орликов переулок, д.5, стр.1, этаж 2, пом.11,
                        <a href={LINKS.NPMIR} target="_blank" rel="noopener noreferrer nofollow"> официальный сайт </a>
                        в информационно-телекоммуникационной сети "Интернет".
                    </p>
                    <ul>
                        <li><a href={LINKS.SBR.MAIN} target="_blank" rel="noopener noreferrer nofollow">Официальный сайт Банка России</a></li>
                        <li><a href={LINKS.SBR.RECEPTION} target="_blank" rel="noopener noreferrer nofollow">Интернет-приемная Банка России</a></li>
                        <li><a href={LINKS.SBR.REGISTRY} target="_blank" rel="noopener noreferrer nofollow">Государственный реестр микрофинансовых организаций</a></li>
                    </ul>
                </div>
                <div className="footer__bottom__right">
                    <p>Потребитель финансовых услуг вправе направить обращение Финансовому уполномоченному
                        Российской Федерации:</p>
                    <ul>
                        <li>Юридический и почтовый адрес: 119017, г. Москва, Старомонетный пер., дом 3, получатель
                            АНО «СОДФУ»</li>
                        <li>Адрес
                            <a href={LINKS.OMBUDSMAN} target="_blank" rel="noopener noreferrer nofollow"> официального сайта финансового уполномоченного </a>
                            в информационно-телекоммуникационной сети "Интернет"
                        </li>
                        <li>Номера телефонов службы обеспечения деятельности финансового уполномоченного:
                            <a href="tel:88002000010">8 (800) 200-00-10</a>,
                            <a href="tel:84951290819">8 (495) 129-08-19</a>
                        </li>
                    </ul>
                    <p>Использование материалов, размещенных на сайте, допускается только с письменного разрешения ООО МКК «Байбол».</p>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;